export const streamName = {
  type: "string",
  minLength: 1,
  maxLength: 255
};
